import React, { useState, useEffect, useRef } from 'react'
import { Button, Modal, Table, Tag, Input, message } from 'antd';
import axios from 'axios';
import { DeleteOutlined, EditOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import AddForm from '../../../components/available-booking-item/AddForm';
import UpdateForm from '../../../components/available-booking-item/UpdateForm';

const { confirm } = Modal;

export default function RoleList() {
  const addForm = useRef(null)
  const updateForm = useRef(null)
  const [messageApi, contextHolder] = message.useMessage();
  const [dataSource, setDataSource] = useState([]);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [currentUpdateData, setcurrentUpdateData] = useState({});
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const typeStringMapping = {
    1: '會議室',
    2: '車輛'
  }


  useEffect(()=>{
    axios.get('/api/available-booking-item').then(res=>{
      setDataSource(res.data)
    })
  },[])

  const columns = [
    {
      title: '項目名稱',
      dataIndex: 'name',
    },
    {
      title: '種類',
      dataIndex:'type',
      render:(value)=>{
        return <div>
          {typeStringMapping[value]}
        </div>
      }
    },
    {
      title: '是否啟用',
      dataIndex:'enable',
      render:(value)=>{
        return <div>
          {value === 1 || value === true? <Tag color="green">是</Tag>:<Tag color="red">否</Tag>}
        </div>
      }
    },
    {
      title: '操作',
      render:(item)=>{
        return <div>
          <Button
            type="primary"
            shape="circle"
            icon={<EditOutlined />}
            onClick={()=>{
              handleUpdateModelOpen(item)
            }}
          />
        </div>
      }
    },
  ]


  const handleAddOk = () => {
    addForm.current.validateFields().then(value=>{
      axios.post('/api/available-booking-item',value)
      .then(res=>{
        //同步dataSource
        let newDataSource = [...dataSource]
        newDataSource.push(res.data)
        setDataSource(newDataSource);
        addForm.current.resetFields();
        success('新增成功')
        setIsAddModalOpen(false)
      })
      .catch(err=>{
        if(typeof err.response.data.errors === 'object' ){
          let error_meaage = Object.values(err.response.data.errors).join(' ')
          error(error_meaage)
        }else{
          error('錯誤，請洽管理員')
          console.error(err)
        }
      })

    });
  }

  const handleUpdateOk = () => {
    updateForm.current.validateFields().then(value=>{
      axios.patch(`/api/available-booking-item/${currentUpdateData.id}`,
  {...value,...{id:currentUpdateData.id}})
      .then(res=>{
        //同步dataSource
        let newDataSource = dataSource.map(item=>
          item.id === res.data.id ? res.data : item
        )
        setDataSource(newDataSource);
        updateForm.current.resetFields();
        success('修改成功')
        setIsUpdateModalOpen(false)
      })
      .catch(err=>{
        if(typeof err.response.data.errors === 'object' ){
          let error_meaage = Object.values(err.response.data.errors).join(' ')
          error(error_meaage)
        }else{
          error('錯誤，請洽管理員')
          console.error(err)
        }
      })

    });
  }

  const handleAddCancel = () =>{
    setIsAddModalOpen(false)
    addForm.current.resetFields();
  }

  const handleUpdateModelOpen = (item)=> {
    setcurrentUpdateData(item)
    Promise.resolve()
    .then(()=>{setIsUpdateModalOpen(true)})
    .then(()=>{updateForm.current.setFieldsValue(item)})
  }

  const handleUpdateCancel = () => {
    setIsUpdateModalOpen(false);
    updateForm.current.resetFields();
  };

  const success = (message) => {
    messageApi.open({
      type: 'success',
      content: message,
    });
  };

  const error = (error) => {
    messageApi.open({
      type: 'error',
      content: error,
    });
  };

  return (
    <div>
      {contextHolder}
      <Button style={{ marginBottom:'10px' }} type="primary" onClick={()=>setIsAddModalOpen(true)}>新增</Button>
      <Table dataSource={dataSource} columns={columns} rowKey="id"/>
      <Modal title="新增可預約項目類型" open={isAddModalOpen} onOk={handleAddOk} onCancel={handleAddCancel}>
        <AddForm ref={addForm}/>
      </Modal>
      <Modal title="修改可預約項目類型" open={isUpdateModalOpen} onOk={handleUpdateOk} onCancel={handleUpdateCancel}>
        <UpdateForm ref={updateForm}/>
      </Modal>
    </div>
  )
}
